import { Banner01Component } from '../banner-01/banner-01.component';
import { debounceTime } from 'rxjs/operators';
import { timer } from 'rxjs';
export class Banner02Component extends Banner01Component {
    constructor() {
        super(...arguments);
        /** 是否自動播放輪播中 */
        this.isCarouselAutoPlaying = true;
        /** 全局監聽焦點事件 */
        this.handleFocusInEventHandler = (event) => {
            const tg = event.target;
            if (this.isCarouselAutoPlaying) {
                // 焦點在容器內
                let find = $(this.el.nativeElement).find(tg);
                if (find.length > 0) {
                    const carouselInstance = window['bootstrap'].Carousel.getInstance(this.carouselHost);
                    carouselInstance.pause();
                    return;
                }
                // 焦點在開關和容器以外
                const carouselInstance = window['bootstrap'].Carousel.getInstance(this.carouselHost);
                carouselInstance.cycle();
            }
        };
        /** 滑鼠進入輪播區域時暫停 */
        this.handleMouseEnter = () => {
            if (this.isCarouselAutoPlaying && this.carouselInstance) {
                this.carouselInstance.pause();
            }
        };
        /** 滑鼠離開輪播區域時繼續 */
        this.handleMouseLeave = () => {
            if (this.isCarouselAutoPlaying && this.carouselInstance) {
                this.carouselInstance.cycle();
            }
        };
        /** 觸控開始時暫停 */
        this.handleTouchStart = (event) => {
            if (this.isCarouselAutoPlaying && this.carouselInstance) {
                // 檢查觸控點是否在輪播容器內
                const touch = event.touches[0];
                const rect = this.carouselHost.getBoundingClientRect();
                const isInsideCarousel = touch.clientX >= rect.left &&
                    touch.clientX <= rect.right &&
                    touch.clientY >= rect.top &&
                    touch.clientY <= rect.bottom;
                if (isInsideCarousel) {
                    this.carouselInstance.pause();
                }
            }
        };
        /** 觸控結束時根據位置決定是否繼續 */
        this.handleTouchEnd = (event) => {
            if (this.isCarouselAutoPlaying && this.carouselInstance) {
                // 檢查觸控結束點是否在輪播容器外
                const touch = event.changedTouches[0];
                const rect = this.carouselHost.getBoundingClientRect();
                const isOutsideCarousel = touch.clientX < rect.left ||
                    touch.clientX > rect.right ||
                    touch.clientY < rect.top ||
                    touch.clientY > rect.bottom;
                if (isOutsideCarousel) {
                    this.carouselInstance.cycle();
                }
            }
        };
    }
    /** 輪播差建是否初始化完成 */
    isCarouselInited() { return !!this.carouselInstance; }
    ngAfterViewInit() {
        this.carouselHost = this.el.nativeElement.querySelector('#banner_Carousel');
        if (this.isBrowser) {
            if (this.carouselOption) {
                this.carouselInstance = new window['bootstrap'].Carousel(this.carouselHost, this.carouselOption);
            }
            else {
                this.carouselInstance = new window['bootstrap'].Carousel(this.carouselHost, this.carouselOption);
            }
            if (this.isCarouselAutoPlaying) { // 可以自動輪播，開啟輪播效果
                timer(1000).subscribe(() => {
                    this.carouselInstance.cycle();
                });
            }
            // 這邊要監聽 mouseenter 事件和 touchend 事件且點擊在 carouselHost 內，且 this.isCarouselAutoPlaying 為真就暫停輪播
            this.carouselHost.addEventListener('mouseenter', this.handleMouseEnter);
            if (this.isTouchScreen) {
                this.carouselHost.addEventListener('touchstart', this.handleTouchStart);
            }
            // 這邊要監聽 mouseleave 事件和 touchend 事件且點擊在 carouselHost 外，且 this.isCarouselAutoPlaying 為真就繼續輪播
            this.carouselHost.addEventListener('mouseleave', this.handleMouseLeave);
            if (this.isTouchScreen) {
                document.addEventListener('touchend', this.handleTouchEnd);
            }
            // 檢查目前幻燈片是不是影音
            this.checkIsVideoCurrently();
            if (this.isTouchScreen && !this.firstPlayDone) {
                window.document.body.addEventListener('touchstart', this.touchScreenInitPlayVideo);
            }
            else {
                if (this.isVideoCurrently) {
                    this.playCurrentVideo2();
                    this.carouselHost.querySelector('.carousel-inner').style.maxHeight = 'unset';
                }
                else {
                    this.carouselHost.querySelector('.carousel-inner').style.maxHeight = '';
                }
            }
            this.carouselHost.addEventListener('slid.bs.carousel', e => {
                if (this.playingVideo) {
                    this.playingVideo.pause();
                    this.playingVideo = undefined;
                }
                this.checkIsVideoCurrently();
                if (this.isVideoCurrently) {
                    this.playCurrentVideo2();
                    this.carouselHost.querySelector('.carousel-inner').style.maxHeight = 'unset';
                }
                else {
                    this.carouselHost.querySelector('.carousel-inner').style.maxHeight = '';
                }
                const activeSlideEl = $(this.carouselHost).find('.active')[0];
                this.activeSlideIndex = +activeSlideEl.id.replace('banner_Carousel_slide_', '');
            });
            this.windowScrollObs.pipe(debounceTime(300)).subscribe(pageYOffset => {
                const videoHeight = $(this.carouselHost).height();
                const direction = pageYOffset - this.lastPageYOffset; // + up, - down
                // const carouselInstance = window['bootstrap'].Carousel.getInstance(this.carouselHost);
                const carouselInstance = this.carouselInstance;
                if (direction > 0 && pageYOffset > videoHeight + 50) {
                    carouselInstance.pause();
                    try {
                        if (this.playingVideo) {
                            this.playingVideo.pause();
                            this.playingVideo = undefined;
                        }
                    }
                    catch (err) { }
                }
                else if (direction < 0 && pageYOffset < videoHeight + 50) {
                    if (this.isCarouselAutoPlaying) {
                        carouselInstance.cycle();
                    }
                    if (!this.playingVideo) {
                        this.playCurrentVideo2();
                    }
                }
                this.lastPageYOffset = pageYOffset;
            });
            // document.body.addEventListener('focusin', this.handleFocusInEventHandler);
        }
    }
    ngOnDestroy() {
        if (this.isBrowser) {
            this.windowScrollObs.complete();
            // document.body.removeEventListener('focusin', this.handleFocusInEventHandler);
            this.carouselHost.removeEventListener('mouseenter', this.handleMouseEnter);
            this.carouselHost.removeEventListener('touchstart', this.handleTouchStart);
            this.carouselHost.removeEventListener('mouseleave', this.handleMouseLeave);
            document.removeEventListener('touchend', this.handleTouchEnd);
        }
    }
    /** 自動輪播切換 */
    togglePlayPause() {
        // const carousel: any = (window as unknown)['bootstrap'].Carousel.getInstance(this.carouselHost);
        this.isCarouselAutoPlaying = !this.isCarouselAutoPlaying;
        if (!this.carouselInstance) { // carousel 還未實例化
            return;
        }
        if (!this.isCarouselAutoPlaying) {
            this.carouselInstance.pause();
        }
        else {
            this.carouselInstance.cycle();
        }
    }
}
